/**
 * Format a number as currency with proper formatting
 * @param {number} amount - The amount to format
 * @param {string} currencySymbol - The currency symbol (default: $)
 * @returns {string} Formatted currency string (e.g., $99,999.99)
 */
export const formatCurrency = (amount, currencySymbol = '$') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `${currencySymbol}0.00`;
  }

  const absAmount = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  // Format with commas and 2 decimal places
  const formatted = absAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `${sign}${currencySymbol}${formatted}`;
};

/**
 * Format currency for display in tables/lists (shorter format for large numbers)
 * @param {number} amount - The amount to format
 * @param {string} currencySymbol - The currency symbol (default: $)
 * @returns {string} Formatted currency string
 */
export const formatCurrencyCompact = (amount, currencySymbol = '$') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `${currencySymbol}0.00`;
  }

  const absAmount = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  // For amounts over 1M, show in compact form
  if (absAmount >= 1000000) {
    return `${sign}${currencySymbol}${(absAmount / 1000000).toFixed(2)}M`;
  }

  // For amounts over 100K, show in compact form
  if (absAmount >= 100000) {
    return `${sign}${currencySymbol}${(absAmount / 1000).toFixed(1)}K`;
  }

  // Otherwise use full format
  return formatCurrency(amount, currencySymbol);
};
